import styled from 'styled-components';

const CopiedAlertContentContainer = styled.div`
    align-items: center;
    display: flex;
    justify-content: center;
    width: 100%;
`;

export default CopiedAlertContentContainer;
